
export class Grafico {
  id: string;
  tipoGrafico: string;
  descricao: string;
  text: string;
  value: string;
}